import React from 'react'
import classnames from 'classnames'
import { List, Text } from '../../..'

import styles from './GemDetail.module.scss'

const Heading = props => (
  <Text
    className={styles.heading}
    align='center'
    weight='light'
    variant='neutralCool'
    variantCount='900'
    {...props}
  />
)

interface ProConListProps {
  className?: string
  children?: React.ReactNode
}

const ProConList = ({ className, children }: ProConListProps) => (
  <List.ProConList className={classnames(styles.list, className)}>
    {children}
  </List.ProConList>
)

const BulletedList = ({ className, ...restProps }) => (
  <List.Bulleted
    className={classnames(className, styles.list)}
    {...restProps}
  />
)

const Strong = props => (
  <Text
    weight='bold'
    element='span'
    variant='neutralCool'
    variantCount='900'
    {...props}
  />
)

const {
  Pro: UnstyledPro,
  Con: UnstyledCon,
  Info: UnstyledInfo,
} = List.ProConList

interface LIProps {
  className?: string
  [x: string]: any // restProps
}

// ProConList is a <ul> that takes <li>'s (<Pro> or <Con>) as children
// we want to style all the li's, giving them a consistent margin-bottom when they are used in the context of a gem
// the weirdness here is due to scss modules not being able to style child <li>'s
// so we have to wrap the component in an HOC to style LI's
// there is probably a nicer way to do this

const LI =
  (Component: any) =>
  ({ className, ...restProps }: LIProps) =>
    <Component className={classnames(styles.li, className)} {...restProps} />

const Pro = LI(UnstyledPro)
const Con = LI(UnstyledCon)
const Info = LI(UnstyledInfo)

export { BulletedList, ProConList, Pro, Con, Info, Heading, Strong }
